/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_4_3Inputs */



/**
* | output |
* | --- |
* | "False negatives (undetected problematic requests)" |
*
* @param {Guardrails_Section_4_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_4_3 = /** @type {((inputs?: Guardrails_Section_4_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_4_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("False Negatives (nicht erkannte problematische Anfragen)")
	return /** @type {LocalizedString} */ ("False negatives (undetected problematic requests)")
});